import { InvoiceForPayment } from 'modules/onboarding/common/components';

import { useOwnerInvoiceForPayment } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerInvoiceForPaymentStep = ({
  canGoBack,
}: PageComponentProps) => {
  const { initialValues, submitLoading, onSubmit, goToBack } =
    useOwnerInvoiceForPayment();

  return (
    <InvoiceForPayment
      canGoBack={canGoBack}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
